import React, { useEffect } from "react";
import { useStyles } from "./style";
import NoRecordFound from "src/components/NoRecordFound";
import { Backdrop, Box, CircularProgress, Grid, Link } from "@material-ui/core";
import { ErrorOutlineRounded, FiberManualRecord } from "@material-ui/icons";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import {
  allNotificationsList,
  loader,
  loader2,
  resetNotification,
  setAllNotifications,
  setUnreadCount,
  unreadCountValue,
} from "src/app-redux/notifications/notificationSlice";
import Drawer from "src/modules/vehicle-management/pages/ListVehicles/components/Drawer";
import { getVehicleDetailsByIdAction } from "src/app-redux/vehicle/actions/vehicleActions";
import {
  getAllNotifications,
  markAllAsRead,
  markAsRead,
} from "src/app-redux/notifications/actions/notificationActions";
import { loader as loader3 } from "src/app-redux/vehicle/vehicleSlice";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroll-component";

export interface INotificationsProps {}

export default function Notifications(props: INotificationsProps) {
  const classes = useStyles();
  const allNotifications = useAppSelector(allNotificationsList);
  const unreadCount = useAppSelector(unreadCountValue);
  const dispatch = useAppDispatch();
  const markAsReadLoader: any = useAppSelector(loader);
  const notificationLoader: any = useAppSelector(loader2);
  const vehicleLoader: any = useAppSelector(loader3);
  const [pageNumber, setPageNumber] = React.useState(0);
  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
  };

  useEffect(() => {
    dispatch(resetNotification());
    getNotifications(pageNumber);
  }, []);

  const getNotifications = async (pageNumber: any) => {
    // const pageNumber = 1;
    const body = {
      userId: Number(localStorage.getItem("nodUserId")),
      pageNumber: pageNumber,
    };
    const res = await dispatch(getAllNotifications(body));
    if (res.payload?.notificationList) {
      dispatch(setUnreadCount(res.payload.unreadnotificationCount));
    }
  };

  const readNotification = async (notificationId: number) => {
    const res = await dispatch(markAsRead({ notificationId }));
    if (res.payload) {
      const notificationsList = allNotifications.map((item: any) => {
        if (item.notificationId == notificationId) return { ...item, isRead: 1 };
        else return item;
      });
      dispatch(setAllNotifications(notificationsList));
      dispatch(setUnreadCount(unreadCount - 1));
    }
  };

  const readAllNotification = async () => {
    const res = await dispatch(
      markAllAsRead({ userId: Number(localStorage.getItem("nodUserId")) })
    );
    if (res.payload) {
      const notificationsList = allNotifications.map((item: any) => {
        return { ...item, isRead: 1 };
      });
      dispatch(setAllNotifications(notificationsList));
      dispatch(setUnreadCount(0));
    }
  };

  const onScrollHandler = async () => {
    const p = pageNumber + 1;
    getNotifications(p);
    setPageNumber(p);
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={markAsReadLoader || vehicleLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Drawer
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
        isRequiredRefresh={false}
      />
      <div className={classes.drawerDetails}>
        {/* History Item  */}
        <Box
          style={{
            textAlign: "end",
            cursor: "pointer",
            marginBottom: "7px",
            color: "#E67817",
          }}
          onClick={() => readAllNotification()}
        >
          <span>Mark all as read</span>
        </Box>
        <InfiniteScroll
          dataLength={allNotifications.length}
          next={() => onScrollHandler()}
          hasMore={true}
          loader={
            <span style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
              {notificationLoader ? <CircularProgress color="inherit" /> : <></>}
            </span>
          }
          // pullDownToRefreshThreshold={50}
          scrollableTarget="scrollableDiv"
          height={"80vh"}
        >
          {allNotifications.length == 0 && !notificationLoader ? (
            <div style={{ marginTop: "20px" }}>
              <NoRecordFound />
            </div>
          ) : (
            allNotifications?.map((item: any, index: any) => (
              <Box
                key={index}
                className={
                  item.isRead == 1
                    ? `${classes.notificationItem}`
                    : `${classes.notificationItem} ${classes.unread}`
                }
                onClick={() => {
                  if (item.isRead == 0 || item.isRead == null)
                    readNotification(item.notificationId);
                }}
                style={item.isRead === 0 ? { cursor: "pointer" } : {}}
              >
                <Grid container direction="row">
                  <Grid item xs={1}>
                    <ErrorOutlineRounded />
                  </Grid>
                  <Grid item xs={10}>
                    <Box>
                      {/* <Link
                      className="customMuiLink"
                      onClick={() => {
                        dispatch(getVehicleDetailsByIdAction(item.gatePassId));
                        setisDrawerOpen(true);
                      }}
                    >
                      {item.vehicleNumber}
                    </Link> */}

                      <span>
                        {item.notificationType === 1
                          ? `ALERT: ${item.consignmentType} Vehicle `
                          : item.notificationType === 2
                          ? `ALERT: Anomaly detected in ${item.consignmentType} Vehicle `
                          : ""}
                        <Link
                          className="customMuiLink"
                          onClick={async () => {
                            const res = await dispatch(
                              getVehicleDetailsByIdAction(item.gatePassId)
                            );
                            if (res?.payload) setisDrawerOpen(true);
                          }}
                        >
                          {item.vehicleNumber}
                        </Link>
                        {item.notificationType === 1
                          ? ` has cleared all processes at ${moment(
                              new Date(item.vehicleStayTime)
                            ).format("DD-MM-YYYY hh:mm A")} and still not exited  ${
                              item.borderTerminal
                            }`
                          : item.notificationType === 2
                          ? ` at ${moment(new Date(item.sendAt)).format(
                              "DD-MM-YYYY hh:mm A"
                            )} at  ${item.borderTerminal}`
                          : ""}
                      </span>
                    </Box>
                  </Grid>
                  <Grid item xs={1}>
                    <Box style={{ textAlign: "end" }}>
                      {(item.isRead == 0 || item.isRead == null) && (
                        <span className={`material-icons ${classes.orangeColor}`}>
                          <FiberManualRecord fontSize="small" />
                        </span>
                      )}
                    </Box>
                  </Grid>
                </Grid>
                <Grid className={classes.timeStamp}>
                  {moment(new Date(item.sendAt)).format("DD-MM-YYYY hh:mm A")}
                </Grid>
              </Box>
            ))
          )}
        </InfiniteScroll>
      </div>
    </>
  );
}
